import useIncludeAirportsManager from '@/src/hooks/srp/includeAirportsManager'
import { IncludeAirportsFilter } from './includeAirportsFilter'

const IncludeAirportsFilterWrapper = () => {
    const { title, nbAirportGroups, handleSelectToggle, handleReset, shouldShowReset, hasAnyOptions } =
        useIncludeAirportsManager()
    if (!hasAnyOptions) return null
    return (
        <IncludeAirportsFilter
            groups={nbAirportGroups}
            onAirportSelect={handleSelectToggle}
            onReset={handleReset}
            shouldShowReset={shouldShowReset}
            title={title}
        />
    )
}

export { IncludeAirportsFilterWrapper }
export default IncludeAirportsFilterWrapper
